import React, { useEffect } from "react";
import { createCallable } from "react-call";
import { useLanguage } from "../contexts/LanguageContext";
import "../styles/components/ConfirmFavoriteDialog.scss";

export const ConfirmFavoriteDialog = createCallable(
    ({ call, title, itemName }) => {
        const { t } = useLanguage();
        useEffect(() => {
            const previousOverflow = document.body.style.overflow;

            document.body.style.overflow = "hidden";

            const handleKeyDown = (event) => {
                if (event.key === "Escape") {
                    call.end(false);
                }
            };

            window.addEventListener("keydown", handleKeyDown);

            return () => {
                document.body.style.overflow = previousOverflow;
                window.removeEventListener("keydown", handleKeyDown);
            };
        }, [call]);

        const handleBackdropClick = (event) => {
            if (event.target === event.currentTarget) {
                call.end(false);
            }
        };

        return (
            <div
                className={`mf-confirm-favorite-backdrop ${call.ended ? "is-closing" : ""
                    }`}
                onMouseDown={handleBackdropClick}
            >
                <section
                    className="mf-confirm-favorite-dialog"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="mf-confirm-favorite-title"
                    aria-describedby="mf-confirm-favorite-description"
                >
                    <div
                        className="mf-confirm-favorite-dialog__warning"
                        aria-hidden="true"
                    >
                        ×
                    </div>

                    <h2 id="mf-confirm-favorite-title">
                        {title}
                    </h2>

                    <p id="mf-confirm-favorite-description">
                        <strong>« {itemName} »</strong>{" "}
                        {t("confirmFavoriteDialog.willBeRemoved")}
                    </p>

                    <p className="mf-confirm-favorite-dialog__notice">
                        {t("confirmFavoriteDialog.notice")}
                    </p>

                    <div className="mf-confirm-favorite-dialog__actions">
                        <button
                            type="button"
                            className="mf-confirm-favorite-dialog__cancel"
                            onClick={() => call.end(false)}
                            autoFocus
                        >
                            {t("confirmFavoriteDialog.cancel")}
                        </button>

                        <button
                            type="button"
                            className="mf-confirm-favorite-dialog__confirm"
                            onClick={() => call.end(true)}
                        >
                            {t("confirmFavoriteDialog.remove")}
                        </button>
                    </div>
                </section>
            </div>
        );
    },

    // Délai permettant à l’animation de fermeture de se terminer
    220
);

ConfirmFavoriteDialog.displayName = "ConfirmFavoriteDialog";